import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63b355f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roll-dices" }

import { Button, IconButton, ModalWindow } from "@/shared/ui";
import { ref } from "vue";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { diceRoll } from "@/shared/helpers/roll";
import RollResult from "@/shared/ui/RollResult/RollResult.vue";

type DiceResult = {
	dice: "lucky" | "default";
	result: -1 | 0 | 1;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'RollDice',
  setup(__props) {

// TODO: Optimize for tablet & mobile usage
const store = useCharactersStore();

const modal = ref(false);
const diceCount = ref(4);
const result = ref<DiceResult[]>([]);

const roll = () => {
	result.value = diceRoll(
		diceCount.value,
		store.characters[store.current].luck
	);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(IconButton), {
        hint: _ctx.$t('dice-roll'),
        type: "Dices",
        variant: "transparent",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (modal.value = true))
      }, null, 8, ["hint"])
    ]),
    _createVNode(_unref(ModalWindow), {
      modelValue: modal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modal).value = $event)),
      title: _ctx.$t('dice-roll')
    }, {
      default: _withCtx(() => [
        _createElementVNode("article", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((diceCount).value = $event)),
            class: "roll-dices__amount",
            type: "number"
          }, null, 512), [
            [_vModelText, diceCount.value]
          ]),
          _createVNode(_unref(Button), {
            title: _ctx.$t('roll-the-dice'),
            onClick: roll
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("roll-the-dice")), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(RollResult, { result: result.value }, null, 8, ["result"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})